export const SET_SEARCH_TERM = 'SET_SEARCH_TERM'
export const RESET_SEARCH_TERM = 'RESET_SEARCH_TERM'
export const GET_SEARCH_TERM = 'GET_SEARCH_TERM'
export const SET_SEARCH_LAB = 'SET_SEARCH_LAB'
export const RESET_SEARCH_LAB = 'RESET_SEARCH_LAB'
export const SET_CURRENT_PRODUCT_ID = 'SET_CURRENT_PRODUCT_ID'
